export default {
  getRole: state =>  {
    return state.role
  }
}